<template>
  <div />
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  computed: {
    showInactiveEmployees () {
      if (this.profile) {
        return this.profile.show_inactive_employees
      } else {
        return false
      }
    },
    showInactiveProjects () {
      if (this.profile) {
        return this.profile.show_inactive_projects
      } else {
        return false
      }
    },
    ...mapGetters([
      'profile',
      'selectedTenant',
      'selectedPeriod',
      'selectedProjects',
      'selectedEmployees',
      'filterQuickSumsByProjectSelection',
      'filterQuickSumsByEmployeeSelection',
      'places'
    ]),
  },
  watch: {
    selectedTenant: {
      handler () {
        this.fetchKnownEmployeeSelectables()
        this.fetchKnownProjectSelectables()
        this.fetchEmployeeQuickSums()
        this.fetchProjectQuickSums()
        this.fetchPlaces()
      },
      immediate: true,
    },
    showInactiveEmployees: {
      handler () {
        this.fetchKnownEmployeeSelectables()
      },
      immediate: true,
    },
    showInactiveProjects: {
      handler () {
        this.fetchKnownProjectSelectables()
      },
      immediate: true,
    },
    selectedPeriod: {
      handler () {
        this.fetchEmployeeQuickSums()
        this.fetchProjectQuickSums()
      },
      immediate: true
    },
    selectedProjects: {
      handler () {
        if (this.filterQuickSumsByProjectSelection) {
          this.fetchEmployeeQuickSums()
        }
      },
      immediate: true
    },
    selectedEmployees: {
      handler () {
        if (this.filterQuickSumsByEmployeeSelection) {
          this.fetchProjectQuickSums()
        }
      },
      immediate: true
    }
  },
  created () {
    this.$root.$on('employeesChanged', () => {
      this.fetchKnownEmployeeSelectables()
    })
    this.$root.$on('projectsChanged', () => {
      this.fetchKnownProjectSelectables()
    })
    this.$root.$on('logsChanged', (log) => {
        this.fetchEmployeeQuickSums()
        this.fetchProjectQuickSums()
        if(this.places && log && this.places.indexOf(log.place) === -1) {
          this.fetchPlaces()
        }
    })
    this.$root.$on('refreshQuickSums', (filterName) => {
      if(filterName === "project") {
        this.fetchEmployeeQuickSums()
      }
      else if (filterName === "employee") {
        this.fetchProjectQuickSums()
      }
    })
  },
  methods: {
    ...mapActions([
      'fetchKnownEmployeeSelectables',
      'fetchKnownProjectSelectables',
      'fetchEmployeeQuickSums',
      'fetchProjectQuickSums',
      'fetchPlaces'
    ]),
  },
}
</script>
